/* eslint-disable react-refresh/only-export-components -- None are components! */

import * as z from "zod";
import { SchemaProceso } from "./Proceso.schema";
import { SchemaEntradaMateriaPrima, SchemaEntradaProducto, SchemaEntradaRawCO2, SchemaEntradaSubProceso } from "./Entrada.schema";
import { SchemaProducto, SchemaRawCO2, SchemaResiduo } from "./Salida.schema";

export const SchemaEntrada = z.discriminatedUnion("subtipo", [
	SchemaEntradaRawCO2,
	SchemaEntradaMateriaPrima,
	SchemaEntradaProducto,
	SchemaEntradaSubProceso,
]);
export type SchemaEntradaIn = z.input<typeof SchemaEntrada>;
export type SchemaEntrada = z.infer<typeof SchemaEntrada>;

export const SchemaSalida = z.discriminatedUnion("subtipo", [
	SchemaRawCO2,
	SchemaProducto,
	SchemaResiduo,
]);
export type SchemaSalidaIn = z.input<typeof SchemaSalida>;
export type SchemaSalida = z.infer<typeof SchemaSalida>;


export const SchemaFlujoEntidad = z.union([
	SchemaEntrada,
	SchemaProceso,
	SchemaSalida,
]);
export type SchemaFlujoEntidadIn = z.input<typeof SchemaFlujoEntidad>;
export type SchemaFlujoEntidad = z.output<typeof SchemaFlujoEntidad>;

export { SchemaProceso } from "./Proceso.schema";
